const SumberDanaSearchCategories = ["pk", "nama_sumber_dana"];

export default SumberDanaSearchCategories;
